import { render, staticRenderFns } from "./OneProductListView.vue?vue&type=template&id=cd88f65a&scoped=true&"
import script from "./OneProductListView.vue?vue&type=script&lang=ts&"
export * from "./OneProductListView.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductListView.vue?vue&type=style&index=0&id=cd88f65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd88f65a",
  null
  
)

export default component.exports